module.exports = __webpack_public_path__ + "static/media/river_level_warning_small.4bfb0354.png";